<template>
  <div class="min-h-screen">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { useHead } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

const i18n = useI18n()

useHead({
  meta: [
    { charset: 'utf-8' },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1',
    },
    {
      name: 'robots',
      content: 'noindex, nofollow',
    },
  ],
  htmlAttrs: {
    lang: i18n.currentLocale,
  },
})
</script>
